import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "announcementsBanners",
    staticClass: "banner-wrapper"
  }, _vm._l(_vm.announcements, function (announcement, index) {
    return _c(VBanner, {
      key: index,
      style: `color: ${_vm.getTextColor(announcement.type)}`,
      attrs: {
        "sticky": "",
        "value": _vm.showInfoBanner(announcement),
        "color": _vm.getColor(announcement.type),
        "dark": true
      },
      scopedSlots: _vm._u([{
        key: "actions",
        fn: function () {
          return [announcement.link && announcement.link.url ? _c(VBtn, {
            staticClass: "banner-link",
            attrs: {
              "target": "_blank",
              "text": "",
              "href": announcement.link.url
            }
          }, [_vm._v("\n        " + _vm._s(announcement.link.message || _vm.$i18n_t('accMgmt.announcement.linkMessage')) + "\n      ")]) : _vm._e(), _c(VBtn, {
            attrs: {
              "text": ""
            }
          }, [_c(VIcon, {
            attrs: {
              "size": "18"
            },
            on: {
              "click": function ($event) {
                return _vm.closeAnnouncement(announcement);
              }
            }
          }, [_vm._v("fal fa-times-circle")])], 1)];
        },
        proxy: true
      }], null, true)
    }, [_c(VIcon, {
      attrs: {
        "slot": "icon",
        "size": "18"
      },
      slot: "icon"
    }, [_vm._v("fal fa-" + _vm._s(_vm.getTypeIcon(announcement.type)))]), _vm._v("\n    " + _vm._s(announcement.message) + "\n    ")], 1);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };